var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('paginated-table', {
    ref: "paginationTable",
    attrs: {
      "store": _vm.pagination,
      "title": _vm.$t('components.operation.OperationTable.title'),
      "predefinedFilter": _vm.predefinedFilter,
      "headers": _vm.headers,
      "baseQuery": _vm.baseQuery
    },
    on: {
      "click:row": _vm.openOperationSideCard
    },
    scopedSlots: _vm._u([{
      key: "item.timestamp.created",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('span', [_vm._v(_vm._s(new Date(item.timestamp.created).toLocaleString()))])];
      }
    }, {
      key: "item.id",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('a', {
          on: {
            "click": function click($event) {
              return _vm.goToOperationDetail(item.id, item.partnerId);
            }
          }
        }, [_vm._v(_vm._s(item.id))])];
      }
    }])
  }), _vm.selectedOperation ? _c('operation-side-card', {
    attrs: {
      "operation": _vm.selectedOperation
    },
    on: {
      "close": function close($event) {
        _vm.selectedOperation = null;
      }
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }